import { RouterModule, Routes } from '@angular/router';
import { HomeLayoutComponent, LoginLayoutComponent } from '../layout';
import { LoginComponent, HomeComponent, BrokerGroupListComponent, SurveyListComponent, PersonnelListComponent, FormsListComponent, SurveyDetailsComponent, BrokerListComponent, ClientListComponent, ClientAddComponent, ConductDetailComponent, ConductListComponent, ForgotPasswordComponent, ResetPasswordComponent } from '../views';
import { APP_ROUTES } from '../constants';
import { FormBuilderComponent } from '@app/form-builder/form-builder/form-builder.component';
import { SessionGuard } from './sessionGuard';
import { BrokerAdminListComponent } from '@app/views/broker-admin/broker-admin-list/broker-admin-list.component';
import { ProfileComponent } from '@app/views/profile/profile.component';
export const appRoutes: Routes = [
    {
        path: '', redirectTo: APP_ROUTES.HOME, pathMatch: "full"
    },
    {
        path: '',
        component: HomeLayoutComponent,
        canActivate: [SessionGuard],
        children: [
            {
                path: APP_ROUTES.HOME,
                component: HomeComponent,
            },
            {
                path: APP_ROUTES.FORM_BUILDER,
                component: FormBuilderComponent,
            },
            {
                path: APP_ROUTES.BROKER_ADMIN,
                component: BrokerAdminListComponent,
            },
            {
                path: APP_ROUTES.BROKER_GROUP,
                component: BrokerGroupListComponent,
            },
            {
                path: APP_ROUTES.SURVEY,
                component: SurveyListComponent,
            },
            {
                path: APP_ROUTES.PERSONNEL,
                component: PersonnelListComponent
            },
            {
                path: APP_ROUTES.FORM,
                component: FormsListComponent
            },
            {
                path: APP_ROUTES.SURVEY_DETAILS,
                component: SurveyDetailsComponent
            },
            {
                path: APP_ROUTES.BROKER,
                component: BrokerListComponent
            },
            {
                path: APP_ROUTES.CLIENT,
                component: ClientListComponent
            },
            {
                path: APP_ROUTES.CLIENT_DETAIL,
                component: ClientAddComponent
            },
            {
                path: APP_ROUTES.CONDUCT,
                component: ConductListComponent
            },
            {
                path: APP_ROUTES.CONDUCT_DETAILS,
                component: ConductDetailComponent
            },
            {
                path: APP_ROUTES.PROFILE,
                component: ProfileComponent
            }
        ]
    },
    {
        path: '',
        component: LoginLayoutComponent,
        children: [
            {
                path: APP_ROUTES.LOGIN,
                component: LoginComponent
            },
            {
                path: APP_ROUTES.FORGOT_PASSWORD,
                component: ForgotPasswordComponent
            },
            {
                path: APP_ROUTES.RESET_PASSWORD,
                component: ResetPasswordComponent
            }
        ]
    },
    { path: '**', redirectTo: APP_ROUTES.HOME, pathMatch: "full" }
]